/* NO NASTIES · feel layer (v10, 22 Oct)
   1. Menu drawer: the links arrive with the drawer instead of fading in
      0.4s after it lands (Stretch staggers them by default).
   2. iOS only fires :active (our pressed states) when a touch listener exists.
   3. The drawer's first accordion ("shop by category") is open by default. An open
      <details> inside the header stops Stretch from hiding the header on scroll, so it
      opens with the drawer and closes again when the drawer does. */
(() => {
  document.addEventListener('touchstart', () => {}, { passive: true });

  customElements.whenDefined('header-menu-drawer-panel').then(() => {
    const Panel = customElements.get('header-menu-drawer-panel');
    if (!Panel || Panel.prototype.__nnFeel) return;
    const show = Panel.prototype.show;
    Panel.prototype.show = function (opts = {}) {
      // initial = the main panel opening with the drawer. Sub-panels keep their slide.
      if (opts.initial === false) return show.call(this, opts);
      this.classList.add('is-visible');
      this.querySelectorAll('.menu-drawer__panel-body > *, .menu-drawer__panel-footer').forEach((el) => {
        el.style.opacity = '';
        el.style.transform = '';
      });
      return Promise.resolve();
    };
    Panel.prototype.__nnFeel = true;
  });

  const drawer = document.getElementById('menu-drawer');
  if (drawer) {
    const startOpen = [...drawer.querySelectorAll('details.nn-dacc[open]')];
    const closeAll = () => drawer.querySelectorAll('details.nn-dacc[open]').forEach((d) => d.removeAttribute('open'));
    closeAll();
    drawer.addEventListener('dialog:before-show', () => startOpen.forEach((d) => d.setAttribute('open', '')));
    drawer.addEventListener('dialog:after-hide', closeAll);
  }
})();

/* 4. keep short "feels ___ good" blanks on one line (feels 9am-to-9pm good never breaks at a hyphen).
      long ones (fresh-off-the-cutting-table) can still wrap so they never overflow a phone. */
(() => {
  const keep = () => document.querySelectorAll('.nn-play').forEach((el) => {
    if (el.textContent.trim().length <= 16) el.style.whiteSpace = 'nowrap';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keep); else keep();
})();

/* 5. questions (.nn-faq__item) and product page drawers (.nn-dd__item) open and close with a slow slide,
      not a jump. the +/− icon flips at the start of the move (the "is-closing" class).
      1 Nov (Apurva): one open at a time in each list (opening one slides the other shut), same motion as the menu. */
(() => {
  if (window.__nnFaqMotion) return;
  window.__nnFaqMotion = true;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ease = { duration: 380, easing: 'cubic-bezier(.2,.7,.2,1)' };
  const SEL = '.nn-faq__item, .nn-dd__item';
  const setOpen = (d, open) => {
    const body = d.querySelector(':scope > div');
    if (still.matches || !body || !body.animate) { d.open = open; d.classList.remove('is-closing'); return; }
    const isOpen = d.open && !d.classList.contains('is-closing');
    if (open === isOpen) return;
    const now = body.offsetHeight;
    if (d._anim) d._anim.cancel();
    const pt = getComputedStyle(body).paddingTop;
    if (open) {
      d.classList.remove('is-closing');
      const wasOpen = d.open;
      d.open = true;
      const h = body.scrollHeight;
      d._anim = body.animate([{ height: (wasOpen ? now : 0) + 'px', paddingTop: wasOpen ? pt : '0px', opacity: wasOpen ? 1 : 0 }, { height: h + 'px', paddingTop: pt, opacity: 1 }], ease);
      d._anim.onfinish = () => { d._anim = null; };
    } else {
      d.classList.add('is-closing');
      d._anim = body.animate([{ height: now + 'px', opacity: 1 }, { height: '0px', paddingTop: '0px', opacity: 0 }], ease);
      d._anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); d._anim = null; };
    }
  };
  document.addEventListener('click', (e) => {
    const sum = e.target.closest('.nn-faq__item > summary, .nn-dd__item > summary');
    if (!sum) return;
    e.preventDefault();
    const d = sum.parentElement;
    const isOpen = d.open && !d.classList.contains('is-closing');
    if (!isOpen && d.parentElement) {
      [...d.parentElement.children].forEach((o) => { if (o !== d && o.matches && o.matches(SEL) && o.open) setOpen(o, false); });
    }
    setOpen(d, !isOpen);
  });
})();

/* v4 · 28 Oct: scroll dots under sideways rows (design codes: 5px, 6 apart, on the right, where you swipe).
   One dot per screenful, at most 5. Hidden when the row fits without scrolling. */
(() => {
  const SEL = '.nn-pgrid--car .nn-grid, .nn-pgrid--rail .nn-grid, .nn-tiles__grid, .nn-looks__grid, .nn-coll__rail, .nn-me__row, .nn-pdpl__grid';
  const rows = new Set();
  const draw = (row) => {
    const box = row.__nnDots; if (!box) return;
    const over = row.scrollWidth - row.clientWidth;
    const visible = getComputedStyle(row).display !== 'none' && !row.closest('[hidden]');
    if (over < 8 || !visible) { box.hidden = true; return; }
    const n = Math.max(2, Math.min(5, Math.ceil(row.scrollWidth / row.clientWidth)));
    if (box.children.length !== n) box.innerHTML = '<i></i>'.repeat(n);
    const at = Math.round((row.scrollLeft / over) * (n - 1));
    [...box.children].forEach((d, i) => d.classList.toggle('is-on', i === at));
    box.hidden = false;
  };
  const add = (row) => {
    if (rows.has(row)) return; rows.add(row);
    const box = document.createElement('div'); box.className = 'nn-dots'; box.setAttribute('aria-hidden', 'true'); box.hidden = true;
    row.after(box); row.__nnDots = box;
    let raf; row.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => draw(row)); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(() => draw(row)).observe(row);
    draw(row);
  };
  const scan = () => document.querySelectorAll(SEL).forEach(add);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', () => rows.forEach(draw));
  document.addEventListener('shopify:section:load', scan);
  /* rows that swap (her / him tiles, looks chips) */
  document.addEventListener('click', () => setTimeout(() => rows.forEach(draw), 60));
})();

/* 1 Nov (Apurva): the older highlight words (.nn-play, .nn-good) are olive from the start. no scroll-in. */
(() => {
  const sel = '.nn-play, .nn-h .nn-good';
  const scan = () => document.querySelectorAll(sel).forEach((el) => el.classList.add('is-in'));
  const go = () => { scan(); document.documentElement.classList.add('nn-hlw'); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', scan);
})();

/* 31 Oct (v6, "C · subtle + highlight"): the highlight word on an olive grey block (CSS: .nn-hlb in assets/nn.css + assets/nn-hl.css).
   a word qualifies when it is a headline's highlighted word, 24px or bigger, on white or light grey (#F2F1EE), and not
   over a photo. 1 Nov (Apurva): no scroll-in. every qualifying word gets its block as soon as the page is ready,
   checked again once images and fonts have loaded, and on resize.
   the homepage pillars (.nn-bl) have their own loop below. */
(() => {
  const SEL = 'main :is(h1, h2, h3, h4, blockquote, .nn-h, [class*="__h"], [class*="__t"], .section-header, .highlighted-heading) em, main :is(.nn-hl, em.nn-mark)';
  const SKIP = '.nn-bl, .nn-so, .nn-foot, .nn-footwrap, footer, [class*="header-group"], .nn-hero, [class*="--over"]';
  const OK_BG = ['rgb(255, 255, 255)', 'rgb(242, 241, 238)'];
  const bgOf = (el) => {
    /* starts at the parent: the word itself already carries the block from the CSS */
    for (let n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
      const cs = getComputedStyle(n);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'image';
      const c = cs.backgroundColor;
      if (c && c !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(c)) return c;
    }
    return 'rgb(255, 255, 255)';
  };
  /* 1 Nov (Apurva): no switching. the decision is made once, from things that are fixed when the page is built
     (the word's size, where it sits, the colour behind it), never from scroll position, sliders or photos still loading.
     the block is drawn by CSS from the first paint (assets/nn.css, "1 Nov · no switching"); this only takes it away from
     words that do not qualify. 18px or bigger now, so the small banner and card titles match the big headlines.
     re-checked on resize only (sizes change between phone and desktop). */
  const fits = (el) => !el.closest(SKIP) && parseFloat(getComputedStyle(el).fontSize) >= 18 && OK_BG.includes(bgOf(el));
  const settle = (el) => { const ok = fits(el); el.classList.add('is-in'); el.classList.toggle('nn-hlb', ok); el.dataset.nnHlb = ok ? 1 : 0; };
  const all = () => [...document.querySelectorAll(SEL)];
  const run = () => all().forEach((el) => { if (!('nnHlb' in el.dataset)) settle(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  let t, w = innerWidth; window.addEventListener('resize', () => { if (innerWidth === w) return; w = innerWidth; clearTimeout(t); t = setTimeout(() => all().forEach(settle), 250); });
})();

/* 31 Oct (v6): the pillars (ridiculously soft. · subtly stylish. · actually sustainable.). only the highlighted word of
   each line (the content team marks it *like this*) takes the olive grey block, one line at a time: 1.5s each, 4.5s a
   round, jumping (no fade). it starts when the pillars come on screen and pauses when they leave.
   reduced motion: no loop, the first line's word stays highlighted. */
(() => {
  const blocks = [...document.querySelectorAll('.nn-bl__h')];
  if (!blocks.length) return;
  document.documentElement.classList.add('nn-trio');
  const linesOf = (b) => [...b.querySelectorAll(':scope > span:not(.nn-bl__sum)')];
  const show = (lines, n) => lines.forEach((l, i) => l.classList.toggle('is-on', i === n));
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { blocks.forEach((b) => show(linesOf(b), 0)); return; }
  const state = new Map();
  const start = (b) => {
    const st = state.get(b) || { n: 0, t: null }; if (st.t) return;
    const lines = linesOf(b); show(lines, st.n);
    st.t = setInterval(() => { st.n = (st.n + 1) % lines.length; show(lines, st.n); }, 1500);
    state.set(b, st);
  };
  const pause = (b) => { const st = state.get(b); if (st && st.t) { clearInterval(st.t); st.t = null; } };
  const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? start(e.target) : pause(e.target))), { threshold: 0.6 });
  blocks.forEach((b) => { show(linesOf(b), 0); io.observe(b); });
})();
